(() => {
  const openers = new WeakMap();

  function renderCatalog(catalog) {
    if (typeof catalog.renderCatalogue === 'function') { catalog.renderCatalogue(); return; }
    const filter = catalog.dataset.llSelectedFilter || 'all';
    const limit = Number(catalog.dataset.llVisibleCount || 6);
    const cards = [...catalog.querySelectorAll('[data-ll-item]')];
    const matching = cards.filter(card => filter === 'all' || card.dataset.category === filter);
    cards.forEach(card => {
      card.hidden = !matching.includes(card) || matching.indexOf(card) >= limit;
    });
    const more = catalog.querySelector('[data-ll-more]');
    if (more) more.hidden = matching.length <= limit;
    const empty = catalog.querySelector('.ll-no-results');
    if (empty) empty.hidden = matching.length > 0;
  }

  function setFilter(catalog, filter) {
    catalog.querySelectorAll('[data-ll-filter]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.llFilter === filter));
    });
    catalog.dataset.llSelectedFilter = filter;
    catalog.dataset.llVisibleCount = '6';
    renderCatalog(catalog);
  }


  function initColourPicker(dialog) {
    const choices = [...dialog.querySelectorAll('[data-ll-design-choice]')];
    if (dialog.dataset.llPickerReady || !choices.length) return;
    const picker = dialog.querySelector('.ll-design-picker'); if (!picker) return;
    const heading = picker.querySelector('h3'); picker.dataset.llOriginalHeading = heading?.textContent || '';
    const groups = new Map();
    for (const choice of choices) {
      choice.dataset.llOptionLabel ||= choice.querySelector('.ll-option-name')?.textContent || '';
      const key = choice.dataset.llType || choice.dataset.llOptionLabel;
      if (!groups.has(key)) groups.set(key, []); groups.get(key).push(choice);
    }
    const controls = document.createElement('div'); controls.className = 'll-selection-controls'; picker.before(controls);
    dialog.dataset.llDesignTotals = String(choices.some(choice => choice.querySelector('template[data-ll-design-rating]')));
    if (choices.some(choice => choice.dataset.llColour)) {
      dialog.dataset.llColourPicker = 'true'; picker.classList.add('ll-colour-picker');
      const typePicker = document.createElement('div'); typePicker.className = 'll-type-picker ll-design-picker';
      const typeHeading = document.createElement('h3'); typeHeading.textContent = picker.dataset.llOriginalHeading;
      const grid = document.createElement('div'); grid.className = 'll-option-grid'; grid.setAttribute('role', 'group'); grid.setAttribute('aria-label', picker.dataset.llOriginalHeading);
      for (const [key, items] of groups) {
        const button = items[0].cloneNode(true); button.removeAttribute('data-ll-design-choice'); button.removeAttribute('data-ll-colour');
        button.dataset.llTypeChoice = key; button.setAttribute('aria-pressed', 'false'); button.setAttribute('aria-label', key); button.setAttribute('title', key);
        button.querySelector('.ll-option-name').textContent = key; button.querySelector('.ll-option-price')?.remove(); grid.append(button);
      }
      typePicker.append(typeHeading, grid); typePicker.hidden = groups.size < 2; controls.append(typePicker);
    }
    controls.append(picker);
    const sizes = [...new Set(choices.map(button => button.dataset.llSize).filter(Boolean))];
    if (sizes.length) {
      const sizePicker = document.createElement('div'); sizePicker.className = 'll-size-picker';
      const sizeHeading = document.createElement('h3'); sizeHeading.textContent = dialog.dataset.llChooseSize || '';
      const sizeGrid = document.createElement('div'); sizeGrid.className = 'll-option-grid ll-size-grid'; sizeGrid.setAttribute('role', 'group'); sizeGrid.setAttribute('aria-label', sizeHeading.textContent);
      for (const size of sizes) {
        const button = document.createElement('button'); button.type = 'button'; button.className = 'll-size-choice'; button.dataset.llSizeChoice = size; button.textContent = size; button.setAttribute('aria-pressed', 'false'); sizeGrid.append(button);
      }
      sizePicker.append(sizeHeading, sizeGrid); controls.append(sizePicker);
    }
    dialog.dataset.llPickerReady = 'true';
  }
  function syncColourPicker(dialog, choice) {
    if (!dialog.dataset.llColourPicker) return;
    const type = choice.dataset.llType;
    const choices = [...dialog.querySelectorAll('[data-ll-design-choice]')];
    for (const button of dialog.querySelectorAll('[data-ll-type-choice]')) {
      const selected = button.dataset.llTypeChoice === type; button.setAttribute('aria-pressed', String(selected));
      if (selected) button.setAttribute('aria-controls', choice.getAttribute('aria-controls'));
      const candidates = choices.filter(option => option.dataset.llType === button.dataset.llTypeChoice);
      const ratingChoice = selected ? choice : candidates.find(option => option.dataset.llColour === choice.dataset.llColour) || candidates[0];
      const totalRating = ratingChoice?.querySelector('template[data-ll-design-rating]')?.content.querySelector('.ll-star-rating');
      const rating = totalRating || ratingChoice?.querySelector('.ll-star-rating');
      const previousRating = button.querySelector('.ll-star-rating');
      if (rating && previousRating) previousRating.replaceWith(rating.cloneNode(true));
      button.setAttribute('aria-label', [button.dataset.llTypeChoice, totalRating ? '' : ratingChoice?.dataset.llColour, rating?.getAttribute('aria-label')].filter(Boolean).join('; '));
    }
    const siblings = choices.filter(button => button.dataset.llType === type);
    for (const button of choices) {
      button.hidden = button.dataset.llType !== type || (!!choice.dataset.llSize && button.dataset.llSize !== choice.dataset.llSize);
      if (button.dataset.llColour) { button.querySelector('.ll-option-name').textContent = button.dataset.llColour; button.setAttribute('title', button.dataset.llColour); }
    }
    const picker = dialog.querySelector('.ll-colour-picker'); const heading = picker.querySelector('h3');
    heading.textContent = choice.dataset.llColour ? dialog.dataset.llChooseColour || picker.dataset.llOriginalHeading : dialog.dataset.llSelectedDesign || picker.dataset.llOriginalHeading;
    picker.hidden = siblings.length === 1 && (!choice.dataset.llColour || dialog.dataset.llDesignTotals === 'true');
    for (const button of dialog.querySelectorAll('[data-ll-size-choice]')) {
      const target = choices.find(option => option.dataset.llType === type && option.dataset.llColour === choice.dataset.llColour && option.dataset.llSize === button.dataset.llSizeChoice);
      button.disabled = !target; button.setAttribute('aria-pressed', String(button.dataset.llSizeChoice === choice.dataset.llSize));
      if (target) button.setAttribute('aria-controls', target.getAttribute('aria-controls')); else button.removeAttribute('aria-controls');
    }
  }
  function selectGalleryFrame(gallery, key) {
    const frames = [...gallery.querySelectorAll('[data-ll-gallery-frame]')];
    if (!frames.some(frame => frame.dataset.llGalleryFrame === key)) return;
    for (const frame of frames) {
      const hidden = frame.dataset.llGalleryFrame !== key;
      if (hidden) frame.querySelector('[data-ll-spin-play][aria-pressed="true"]')?.click(); frame.hidden = hidden;
    }
    for (const button of gallery.querySelectorAll('[data-ll-gallery-image]')) button.setAttribute('aria-pressed', String(button.dataset.llGalleryImage === key));
  }
  function initGalleries(scope = document) {
    for (const gallery of scope.querySelectorAll('.ll-product-gallery[data-ll-gallery]')) {
      if (gallery.dataset.llGalleryReady) continue;
      const frames = [...gallery.querySelectorAll('[data-ll-gallery-frame]')]; const buttons = [...gallery.querySelectorAll('[data-ll-gallery-image]')];
      if (!frames.length || !buttons.length) continue;
      gallery.dataset.llGalleryReady = 'true'; const selected = buttons.find(button => button.getAttribute('aria-pressed') === 'true') || buttons[0];
      selectGalleryFrame(gallery, selected.dataset.llGalleryImage); const rail = gallery.querySelector('.ll-gallery-thumbnails'); if (rail) rail.hidden = buttons.length < 2;
    }
  }

  const mobileProductViewport = matchMedia('(max-width:749px)');
  const mobileProductLayouts = new WeakMap();
  function restoreMobileProductLayout(dialog) {
    const state = mobileProductLayouts.get(dialog);
    if (!state) return;
    for (const {node, anchor} of state.moves.reverse()) {
      if (anchor.parentNode) { anchor.replaceWith(node); }
    }
    if (state.heading) state.heading.textContent = state.title;
    state.standaloneTitle?.classList.remove('ll-mobile-product-title');
    delete dialog.dataset.llMobileFlow;
    mobileProductLayouts.delete(dialog);
  }
  function arrangeMobileProductLayout(dialog) {
    if (!dialog.hasAttribute('data-ll-mobile-layout') || !mobileProductViewport.matches || mobileProductLayouts.has(dialog)) return;
    const panel = dialog.querySelector('[data-ll-selection-panel]:not([hidden])') || dialog;
    const grid = panel?.querySelector('.ll-dialog-grid');
    const summary = panel?.querySelector('.ll-purchase-summary');
    const heading = dialog.querySelector('.ll-selection-heading h1,.ll-selection-heading h2');
    const selectedTitle = summary?.querySelector('h1,h2');
    const media = panel?.querySelector('.ll-product-media-column');
    const gallery = media?.querySelector('.ll-product-gallery,.ll-gallery');
    const controls = summary?.querySelector('.ll-selection-controls');
    const form = summary?.querySelector('.ll-product-form');
    if (!grid || !summary || !selectedTitle || !media || !gallery || !form) return;
    const state = {heading, title:heading?.textContent, moves:[], standaloneTitle:heading ? null : selectedTitle};
    const move = (node, place) => {
      const anchor = document.createComment('');
      node.before(anchor); state.moves.push({node,anchor}); place(node);
    };
    const sections = [...media.children].filter(node => node !== gallery);
    if (controls) move(controls, node => summary.prepend(node));
    const delivery = summary.querySelector('[data-ll-delivery-target]');
    if (delivery) move(delivery, node => form.after(node));
    if (!heading) { selectedTitle.classList.add('ll-mobile-product-title'); move(selectedTitle, node => grid.append(node)); }
    move(gallery, node => grid.append(node));
    move(summary, node => grid.append(node));
    for (const section of sections) move(section, node => grid.append(node));
    if (heading) heading.textContent = selectedTitle.textContent;
    dialog.dataset.llMobileFlow = 'true';
    mobileProductLayouts.set(dialog, state);
  }
  mobileProductViewport.addEventListener('change', () => {
    for (const dialog of document.querySelectorAll('[data-ll-mobile-layout]')) {
      restoreMobileProductLayout(dialog);
      arrangeMobileProductLayout(dialog);
    }
  });

  function showDesign(dialog, pieceId, announce = true) {
    if (!dialog) return;
    const savedScroll = dialog instanceof HTMLDialogElement ? dialog.scrollTop : null;
    const savedFocus = document.activeElement;
    restoreMobileProductLayout(dialog);
    initColourPicker(dialog);
    const restoreControlFocus = !!dialog.querySelector('.ll-selection-controls')?.contains(savedFocus);
    const choices = [...dialog.querySelectorAll('[data-ll-design-choice]')]; const panels = [...dialog.querySelectorAll('[data-ll-selection-panel]')];
    const active = panels.find(panel => panel.dataset.llPieceId === pieceId); const choice = choices.find(button => button.dataset.llDesignChoice === pieceId); if (!active || !choice) return;
    for (const button of choices) button.setAttribute('aria-pressed', String(button === choice)); for (const panel of panels) panel.hidden = panel !== active;
    syncColourPicker(dialog, choice);
    const controls = dialog.querySelector('.ll-selection-controls'); const summary = active.querySelector('.ll-purchase-summary'); const form = summary?.querySelector('.ll-product-form');
    if (controls && form) {
      form.before(controls);
    }
    initGalleries(active);
    arrangeMobileProductLayout(dialog);
    if (restoreControlFocus && savedFocus?.isConnected && !savedFocus.closest('[hidden]') && document.activeElement !== savedFocus) savedFocus.focus({ preventScroll:true });
    if (savedScroll !== null) { dialog.scrollTop = savedScroll; requestAnimationFrame(() => { if (dialog.open) dialog.scrollTop = savedScroll; }); }
    const status = dialog.querySelector('[data-ll-design-status]');
    if (status && announce) { const name = choice.dataset.llOptionLabel || choice.querySelector('.ll-option-name').textContent; status.textContent = status.dataset.llStatusTemplate.replace('__design__', name); }
  }

  function openDialog(dialog, opener, updateHash = true) {
    if (!dialog) return;
    document.querySelectorAll('.ll-dialog[open]').forEach(current => {
      if (current !== dialog) current.close();
    });
    if (opener) openers.set(dialog, opener);
    if (!dialog.open) dialog.showModal();
    dialog.scrollTop = 0;
    initGalleries(dialog);
    const choice = dialog.querySelector('[data-ll-design-choice][aria-pressed="true"]') || dialog.querySelector('[data-ll-design-choice]');
    if (choice) showDesign(dialog, choice.dataset.llDesignChoice, false);
    else arrangeMobileProductLayout(dialog);
    if (updateHash && dialog.dataset.llSelectionAnchor) {
      const url = new URL(window.location.href);
      url.hash = dialog.dataset.llSelectionAnchor;
      history.replaceState(history.state, '', url);
    }
  }

  function openHashSelection() {
    const hash = window.location.hash.slice(1);
    if (!hash.startsWith('selection-')) return;
    const card = document.getElementById(hash) || [...document.querySelectorAll('[data-ll-selection-aliases]')].find(item => item.dataset.llSelectionAliases.split(',').map(key => 'selection-' + key.trim()).includes(hash));
    if (!card?.matches('[data-ll-selection]')) return;
    const catalog = card.closest('[data-ll-catalog]');
    if (catalog) {
      setFilter(catalog, card.dataset.category || 'trees');
      catalog.dataset.llVisibleCount = '50';
      renderCatalog(catalog);
    }
    catalog?.revealSelection?.(card);
    const opener = card.querySelector('[data-ll-open]');
    const dialog=document.getElementById(opener?.dataset.llOpen);
    openDialog(dialog,opener,false);
    const legacyVariant={
      'selection-floor-wood-oak-wood-set':'55517633478985',
      'selection-wheel-slim-base':'55552153387337'
    }[hash];
    if(legacyVariant&&dialog){
      const panel=dialog.querySelector('[data-ll-selection-panel][data-ll-variant-id="'+legacyVariant+'"]') || dialog.querySelector('[name="id"][value="'+legacyVariant+'"]')?.closest('[data-ll-selection-panel]');
      if(panel)showDesign(dialog,panel.dataset.llPieceId,false);
    }
  }

  function init(scope = document) {
    initGalleries(scope);
    scope.querySelectorAll('[data-ll-native-fallback]').forEach(f=>{f.hidden=!!document.querySelector('[data-ll-inline-selection]'); if(!f.hidden) arrangeMobileProductLayout(f);});
    scope.querySelectorAll('[data-ll-inline-selection]').forEach(detail=>{
      const input=detail.querySelector('[name="id"][value="'+detail.dataset.llSelectedVariant+'"]');
      const panel=detail.querySelector('[data-ll-selection-panel][data-ll-variant-id="'+detail.dataset.llSelectedVariant+'"]') || input?.closest('[data-ll-selection-panel]');
      const choice=detail.querySelector('[data-ll-design-choice]');
      if(choice)showDesign(detail,panel?.dataset.llPieceId||choice.dataset.llDesignChoice,false);
    });
    scope.querySelectorAll('[data-ll-catalog]').forEach(catalog => {
      catalog.dataset.llSelectedFilter ||= 'all';
      renderCatalog(catalog);
    });
  }

  document.addEventListener('click', event => {
    const sizeChoice = event.target.closest('[data-ll-size-choice]');
    if (sizeChoice) {
      if (sizeChoice.disabled) return;
      const dialog = sizeChoice.closest('[data-ll-inline-selection],dialog'), active = dialog?.querySelector('[data-ll-design-choice][aria-pressed="true"]');
      const next = [...dialog.querySelectorAll('[data-ll-design-choice]')].find(button => button.dataset.llType === active?.dataset.llType && button.dataset.llColour === active?.dataset.llColour && button.dataset.llSize === sizeChoice.dataset.llSizeChoice);
      if (next) showDesign(dialog, next.dataset.llDesignChoice);
      return;
    }
    const typeChoice=event.target.closest('[data-ll-type-choice]');
    if(typeChoice){
      const dialog=typeChoice.closest('[data-ll-inline-selection],dialog'),active=dialog.querySelector('[data-ll-design-choice][aria-pressed="true"]');
      const candidates=[...dialog.querySelectorAll('[data-ll-design-choice]')].filter(b=>b.dataset.llType===typeChoice.dataset.llTypeChoice);
      const next=active?.dataset.llSize ? candidates.find(b=>b.dataset.llColour===active.dataset.llColour&&b.dataset.llSize===active.dataset.llSize) : candidates.find(b=>b.dataset.llColour&&b.dataset.llColour===active?.dataset.llColour)||candidates[0];
      if(next)showDesign(dialog,next.dataset.llDesignChoice);
      return;
    }
    const choice = event.target.closest('[data-ll-design-choice]');
    if (choice) {
      const dialog = choice.closest('[data-ll-inline-selection],dialog');
      showDesign(dialog, choice.dataset.llDesignChoice);

      return;
    }
    const opener = event.target.closest('[data-ll-open]');
    if (opener) {
      event.preventDefault();
      openDialog(document.getElementById(opener.dataset.llOpen), opener);
      return;
    }
    const close = event.target.closest('[data-ll-close]');
    if (close) {
      close.closest('dialog').close();
      return;
    }
    const thumbnail = event.target.closest('[data-ll-gallery-image]');
    if (thumbnail) {
      const gallery = thumbnail.closest('[data-ll-gallery]');
      selectGalleryFrame(gallery, thumbnail.dataset.llGalleryImage);
      return;
    }
    const filter = event.target.closest('[data-ll-filter]');
    if (filter) {
      setFilter(filter.closest('[data-ll-catalog]'), filter.dataset.llFilter);
      return;
    }
    const more = event.target.closest('[data-ll-more]');
    if (more) {
      const catalog = more.closest('[data-ll-catalog]');
      catalog.dataset.llVisibleCount = String(Number(catalog.dataset.llVisibleCount || 6) + 6);
      renderCatalog(catalog);
      return;
    }
    const category = event.target.closest('[data-ll-category]');
    if (category) {
      const targetAnchor = (category.getAttribute('href') || '').split('#')[1];
      const catalog = (targetAnchor ? document.getElementById(targetAnchor) : null) || document.querySelector('[data-ll-catalog]');
      if (catalog) {
        setFilter(catalog, category.dataset.llCategory);
        document.querySelectorAll('.ll-mobile-nav[open]').forEach(menu => menu.removeAttribute('open'));
      } else {
        sessionStorage.setItem('ll-category', category.dataset.llCategory);
      }
    }
    if (event.target.matches('.ll-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) {
        event.target.close();
      }
    }
  });

  document.addEventListener('keydown', event => {
    if (event.altKey || event.ctrlKey || event.metaKey || !(event.target instanceof Element)) return;
    const button = event.target.closest('[data-ll-type-choice],[data-ll-design-choice],[data-ll-size-choice],[data-ll-gallery-image]');
    if (!button || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const group = button.closest('.ll-option-grid,.ll-gallery-thumbnails'); if (!group) return;
    const buttons = [...group.querySelectorAll('button')].filter(item => !item.hidden && !item.disabled);
    const current = buttons.indexOf(button); if (current < 0 || buttons.length < 2) return;
    const rtl = getComputedStyle(group).direction === 'rtl'; const step = (event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1);
    const index = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (current + step + buttons.length) % buttons.length;
    event.preventDefault(); const next = buttons[index]; next.focus({ preventScroll:true }); next.click();
    next.scrollIntoView({ block:'nearest', inline:'nearest', behavior:'instant' });
  });

  document.addEventListener('close', event => {
    if (event.target.matches('.ll-dialog')) openers.get(event.target)?.focus();
  }, true);

  document.addEventListener('shopify:section:load', event => {
    init(event.target);
    openHashSelection();
  });

  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('[data-ll-selection-panel]');
    const card = event.target.closest('[data-ll-item]');
    if (!card) return;
    const catalog = card.closest('[data-ll-catalog]');
    if (catalog) {
      setFilter(catalog, 'all');
      catalog.dataset.llVisibleCount = '50';
      renderCatalog(catalog);
    }
    if (panel) {
      const dialog = panel.closest('dialog');
      openDialog(dialog, card.querySelector('[data-ll-open]'), false);
      showDesign(dialog, panel.dataset.llPieceId, false);
    }
  });

  window.addEventListener('hashchange', openHashSelection);
  init();
  const saved = sessionStorage.getItem('ll-category');
  const catalog = document.querySelector('[data-ll-catalog]');
  if (saved && catalog) {
    setFilter(catalog, saved);
    sessionStorage.removeItem('ll-category');
  }
  openHashSelection();
})();


(() => {
  const states = new WeakMap();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function initPhotos(scope = document) {
    scope.querySelectorAll('[data-ll-photo-carousel]').forEach(gallery => {
      if (states.has(gallery)) return;
      const frames = [...gallery.querySelectorAll('[data-ll-photo-frame]')];
      const play = gallery.querySelector('[data-ll-photo-play]');
      const count = gallery.querySelector('[data-ll-photo-count]');
      const state = { index: 0, playing: !reduced.matches, visible: false, timer: null };
      states.set(gallery, state);
      function show(index) {
        state.index = (index + frames.length) % frames.length;
        frames.forEach((frame, i) => { frame.hidden = i !== state.index; });
        count.textContent = `${state.index + 1} / ${frames.length}`;
      }
      function sync() {
        clearInterval(state.timer);
        play.setAttribute('aria-pressed', String(state.playing));
        play.textContent = state.playing ? play.dataset.pauseLabel : play.dataset.playLabel;
        if (state.playing && state.visible && frames.length > 1) {
          state.timer = setInterval(() => show(state.index + 1), 5000);
        }
      }
      function pause() { state.playing = false; sync(); }
      gallery.querySelector('[data-ll-photo-prev]').addEventListener('click', () => { pause(); show(state.index - 1); });
      gallery.querySelector('[data-ll-photo-next]').addEventListener('click', () => { pause(); show(state.index + 1); });
      play.addEventListener('click', () => { state.playing = !state.playing; sync(); });
      gallery.addEventListener('pointerenter', pause);
      gallery.addEventListener('focusin', event => { if (event.target !== play) pause(); });
      reduced.addEventListener('change', () => { if (reduced.matches) pause(); });
      new IntersectionObserver(entries => {
        state.visible = entries[0].isIntersecting;
        sync();
      }).observe(gallery);
      show(0); sync();
    });
  }
  const style = document.createElement('style');
  style.textContent = '.ll-photo-carousel{width:100%}.ll-carousel-frame{margin:0;aspect-ratio:1;display:flex;align-items:center;justify-content:center}.ll-carousel-frame[hidden]{display:none!important}.ll-carousel-frame img{width:100%;height:100%;object-fit:contain}.ll-carousel-controls{display:flex;gap:12px;justify-content:center;align-items:center;padding:16px;flex-wrap:wrap}.ll-carousel-controls button{min-width:44px;min-height:44px;padding:8px 14px;background:var(--ll-cream);color:var(--ll-espresso);border:1px solid currentColor;cursor:pointer;border-radius:3px}.ll-carousel-controls button:focus-visible{outline:2px solid currentColor;outline-offset:3px}';
  document.head.append(style);
  initPhotos();
  document.addEventListener('shopify:section:load', event => initPhotos(event.target));
})();
